export default __webpack_public_path__ + "static/media/ProfileImage.cd7f941a.svg";